import localefileJa from './locale/ja/index';
import localefileEn from './locale/en/index';

const navigator = window.navigator;
const locale = {
    ja: { name: 'ja', data: localefileJa },
    en: { name: 'en', data: localefileEn },
};

const getPropName = (): string => {
    // ブラウザ種別毎に言語の入っているプロパティ名が異なるので判定
    const propName = ['language', 'userLanguage', 'browserLanguage', 'userLanguage'].find(
        propName => propName in navigator
    );

    return propName;
};

const getBrowerLanguage = (): string => {
    const propName = getPropName();
    return navigator[propName].substr(0, 2);
};

const getLocale = (): any => {
    const lang = getBrowerLanguage();
    return lang in locale ? locale[lang] : locale.en;
};

const getAllLocale = (): Array<{ name: string; data: any }> => {
    return [locale.ja, locale.en];
};

export { getLocale, getAllLocale };
